(function () {
  "use strict";

  AddNewUserToManageCtrl.$inject = ['$scope', 'resolveData', 'refreshSession'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AddNewUserToManageCtrl', AddNewUserToManageCtrl);

  function AddNewUserToManageCtrl($scope, resolveData, refreshSession) {

    // small shim to populate resolvedData
    $scope.resolvedData = resolveData;

    refreshSession.refresh();
  }

})();
